import { makeStyles, withStyles } from '@mui/styles';
import MuiBottomNavigationAction from '@mui/material/BottomNavigationAction';
import MuiListItemButton from '@mui/material/ListItemButton';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },

  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    marginLeft: drawerWidth,
    background: '#fff',
  },

  appBarTypography: {
    flexGrow: 1,
    color: '#313539',
  },

  toolbar: theme.mixins.toolbar,

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },

  dashboardNavTab: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },

  welcome: {
    display: 'flex',
    height: '80vh',
    alignItems: 'center',
    justifyContent: 'center',
  },

  drawerIconItem: {
    display: 'inline-flex',
    minWidth: 56,
    flexShrink: 0,
  },

  drawerTextItem: {
    fontFamily: '"Quicksand", sans-serif',
  },

  homeButton: {
    position: 'absolute',
    bottom: 1,
    width: '100%',
  },
}));

const BottomNavigationAction = withStyles({
  root: {
    maxwidth: 'none',
    color: 'rgba(0, 0, 0, 0.74)',
    '&.Mui-selected': {
      backgroundColor: 'rgb(255, 177, 93)',
      color: 'white',
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'rgb(255, 145, 28)',
      color: 'white',
      transition: '0.2s ease-in',
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.15)',
      color: 'white',
      transition: '0.2s ease-in',
    },
  },
})(MuiBottomNavigationAction);

const ListItem = withStyles({
  root: {
    color: 'rgba(0, 0, 0, 0.74)',
    '&.Mui-selected': {
      backgroundColor: 'rgb(255, 177, 93)',
      color: 'white',
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'rgb(255, 145, 28)',
      color: 'white',
      transition: '0.2s ease-in',
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.15)',
      color: 'white',
      transition: '0.2s ease-in',
    },
  },
})(MuiListItemButton);

export { useStyles, BottomNavigationAction, ListItem };
